export default "__VITE_ASSET__5624075c__"